import type { Service } from "@/types";

export const services: Service[] = [
  {
    id: "s1",
    icon: "ri-film-line",
    title: "影视内容制作",
    desc: "覆盖电影、电视剧、综艺等多种形态，从剧本开发到成片交付，提供完整的内容制作服务。",
    features: ["剧本开发", "拍摄制作", "后期剪辑", "调色与声音"],
  },
  {
    id: "s2",
    icon: "ri-megaphone-line",
    title: "宣传发行",
    desc: "整合线上线下渠道资源，为影视作品提供从宣传策略到发行落地的全流程支持。",
    features: ["宣发策划", "物料设计", "渠道发行", "口碑运营"],
  },
  {
    id: "s3",
    icon: "ri-vidicon-line",
    title: "品牌影像",
    desc: "为品牌与企业打造兼具质感与传播力的影像内容，包括广告片、宣传片与纪录片。",
    features: ["品牌广告片", "企业宣传片", "产品短片", "纪录片"],
  },
  {
    id: "s4",
    icon: "ri-live-line",
    title: "新媒体运营",
    desc: "面向短视频与社交平台的内容运营服务，帮助优质内容获得更广泛的传播与关注。",
    features: ["内容策划", "短视频制作", "账号运营", "数据复盘"],
  },
  {
    id: "s5",
    icon: "ri-calendar-event-line",
    title: "活动与盛典",
    desc: "策划并执行发布会、首映礼、行业论坛等各类活动，提供专业的一站式执行保障。",
    features: ["活动策划", "现场执行", "嘉宾统筹", "直播转播"],
  },
  {
    id: "s6",
    icon: "ri-lightbulb-line",
    title: "创意与策划",
    desc: "围绕内容与品牌的核心创意服务，从概念孵化到方案落地，为项目注入持久生命力。",
    features: ["创意概念", "内容策划", "IP孵化", "方案落地"],
  },
];